module.exports = __webpack_public_path__ + "img/MichaelKorycki_140x140_rund.9fdbfb21.jpg";